import {
  List,
  Datagrid,
  TextField,
  DateField,
  EditButton,
  TextInput,
  Filter,
  useLocale,
} from "react-admin";

const JobApplicationSourceFilter = (props: any) => (
  <Filter {...props}>
    <TextInput source="name" />
  </Filter>
);

export const JobApplicationSourceList = () => {
  const locale = useLocale();
  return (
    <List filters={<JobApplicationSourceFilter />} sort={{ field: "id", order: "DESC" }}>
      <Datagrid bulkActionButtons={false}>        
        <TextField source="id" />
        <TextField source="name" />
        <EditButton />
      </Datagrid>
    </List>
  );
};
